import { Container, Image, Nav, Navbar } from 'react-bootstrap';
import { LuSettings } from "react-icons/lu";
import i18n from '../i18n';
import { useState, useEffect } from 'react';
import LangToggle from './LangToggle';
import ThemeToggle from './ThemeToggle';
// import Search from './Search';
import UserComp from './UserComp';
import SessionUtil from '../util/SessionUtil';
import Notifications from './Notifications';


function Header() {

    const [lang, setLang] = useState(SessionUtil.getLang() || 'en');
    const typeUser = SessionUtil.getTypeUser(); 
    useEffect(() => {
        if (lang === 'ar') {
            document.body.classList.add('rtl');
        } else {
            document.body.classList.remove('rtl');
        }
    }, [lang])
    const handleLangChange = (newLang) => {
        i18n.changeLanguage(newLang);
        setLang(newLang);
        SessionUtil.setLang(newLang)
    };
    return (
        <Navbar collapseOnSelect expand="md">
            <Container className="bg-navbar p-3 rounded mx-4 mx-xxl-auto shadow-sm gap-3" fluid='xxl' >
                <Navbar.Brand href={typeUser === '1' ?  "/operation": "/driver-list"}><Image alt="image" src={'/images/logo.png'} /></Navbar.Brand>
                <Navbar.Toggle className='border-0' aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav" className='justify-content-end'>
                    {/* <Nav className="m-inline-end">
                        <Search typeHeader={true} />
                    </Nav> */}
                    <Nav className='flex-row align-items-center mt-2 mt-md-0'>
                        <LangToggle lang={lang} handleLangChange={handleLangChange} />
                        <ThemeToggle />
                        {typeUser === '4' && <Nav.Link href='/settings'><LuSettings size={'20'} className='icon-color-grey' /></Nav.Link>}
                       {(typeUser === '4' || typeUser === '1') &&  <Notifications />}
                        <UserComp />
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Header;